export const mutations = {
  setDepartment: function (state, data) {
    state.department = data;
  },
};
